import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { rulesList, rulesConflicts } from "../rules";

export const useRule = (type, operator, predicat, conditions) => {
  const [typeOptions, setTypeOptions] = useState([]);
  const [operatorOptions, setOperatorOptions] = useState([]);
  const [predicatOptions, setPredicatOptions] = useState([]);
  const [conflicts, setconflicts] = useState([]);

  useEffect(() => {
    setTypes();
    onSetConflicts();
  }, []);

  useEffect(() => {
    setOperators(type);
  }, [type]);

  useEffect(() => {
    onSetConflicts();
  }, [operator, operatorOptions, predicatOptions, predicat]);

  useEffect(() => {
    setPredicats(type, operator, conditions, conflicts);
  }, [conflicts.length, operator, operatorOptions]);

  const { t } = useTranslation();

  const setTypes = () => {
    const types = [];

    rulesList.map((it) => {
      types.push({ label: t(it.label), value: it.label, isDisabled: false });
    });

    setTypeOptions(types);
  };

  const setOperators = (type) => {
    const operators = [];
    const typeObj = rulesList.find((rule) => rule.label === type);

    typeObj?.options?.map((item) => {
      operators.push({
        label: item.label,
        value: item.label,
        predicats: item.options,
        isDisabled: false,
      });
    });

    setOperatorOptions(operators);
  };

  const checkPredicat = (
    type,
    operator,
    predicat,
    conditions,
    allConflicts,
  ) => {
    const has_conflict = allConflicts?.some(
      (conflict) =>
        conflict.type === type &&
        conflict.operator === operator &&
        predicat === conflict.predicat,
    );
    const has_duplicate = conditions?.some(
      (condition) =>
        condition.type === type &&
        condition.operator === operator &&
        condition.predicat === predicat,
    );

    return has_conflict || has_duplicate;
  };

  const setPredicats = (type, op, conditions, conflicts) => {
    const predicats = [];

    const typeObj = operatorOptions.find((operator) => operator.value === op);

    typeObj?.predicats.map((item) => {
      predicats.push({
        label: item,
        value: item,
        isDisabled: checkPredicat(type, op, item, conditions, conflicts),
      });
    });

    setPredicatOptions(predicats);
  };

  const onSetConflicts = () => {
    let conflicts = [];

    conditions?.map((condition) => {
      rulesConflicts?.map((rule) => {
        if (
          rule.predicat === condition.predicat &&
          condition.operator === rule.operator
        ) {
          conflicts = [...conflicts, ...rule.conflicts_with].reduce(
            (acc, item) => {
              if (
                !acc.some(
                  (ac) =>
                    item.operator === ac.operator &&
                    item.predicat === ac.predicat,
                )
              ) {
                acc.push(item);
              }
              return acc;
            },
            [],
          );
        }
      });
    });

    setconflicts(conflicts);
  };

  return {
    typeOptions,
    operatorOptions,
    predicatOptions,
  };
};
